<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-row flex-wrap gap-2">
      <BaseButton
        v-for="item in views"
        :key="item.label"
        :title="item.label"
        :icon="item.icon"
        size="small"
        color="primary"
        :is-outline="item.type !== view"
        inverse-icon-order
        @click="localView = item.type"
      />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'ViewSelector',
  components: { BaseButton, FontAwesomeIcon },
  props: {
    view: {
      type: String,
      required: true
    },
    views: {
      type: Array,
      required: true
    }
  },
  emits: [
    'update:view',
    'update:timelineGroupBy',
    'update:timelineLocationFilter'
  ],
  computed: {
    localView: {
      get() {
        return this.view
      },
      set(value) {
        this.$emit('update:view', value)
      }
    }
  }
}
</script>

<style scoped></style>
